import { useAppDispatch, useAppSelector } from "@/store"
import {
  changeViewType,
  LoginApiVersion,
  LoginStatus,
  selectLoginState,
  setLoginApiVersion,
  updateLoginStatus,
  ViewType,
} from "@/stores/login_slice"

import React, { useState } from "react"
import { useLoginNew } from "./login_hook"
import {
  Button,
  Flex,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useToast,
} from "@chakra-ui/react"
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons"

import { UserUsecase } from "@/usecases/user"
import { BizError } from "@/models/biz_model"
import { validatePassword, PasswordValidationResult } from "@/utils/passVerify"
import { setLoginPwd } from "@/stores/auth_slice"

const SetKCPwdView: React.FC = () => {
  const [pwdVal, setPwdVal] = useState<string>("")
  const { currentUser, msg } = useAppSelector(selectLoginState)

  const toast = useToast()
  const dispatch = useAppDispatch()
  const loginNew = useLoginNew()
  const [showViewIcon, setShowViewIcon] = useState(false)

  const setErrMsg = (msg: string) => {
    dispatch(updateLoginStatus({ msg, status: LoginStatus.error }))
  }

  const handleConfirmPwd = async () => {
    const pwdStr = pwdVal.trim()

    if (pwdStr === null || pwdStr.length === 0) {
      setErrMsg("请输入企业登录密码")
      return
    }

    if (pwdStr === currentUser?.account) {
      setErrMsg("密码不能和账号相同")
      return
    }

    // 弱密码校验
    const verifyRes: PasswordValidationResult = validatePassword(
      pwdStr,
      currentUser?.uid + "@kingsoft.com"
    )
    // 校验规则中通过@判断是否是邮箱，kcLoginParams.uid是wangliping2这种，没有@kingsoft.com，所以加上
    if (!verifyRes.isValid) {
      setErrMsg(`${verifyRes.errors.join(", ")}`)
      return
    }

    // 企业登录，设置密码
    const setKCPassRes = await UserUsecase.setKCPass(pwdStr)

    if (setKCPassRes instanceof BizError) {
      setErrMsg(setKCPassRes.displayErrorMsg)
      return
    }

    toast({
      title: "企业密码设置成功",
      status: "success",
      duration: 9000,
      position: "top",
      isClosable: true,
    })

    dispatch(setLoginPwd(pwdStr))
    // 企业登录，设置密码成功之后，关闭设置密码弹窗，切换到输入密码页，进行登录，连接云桌面
    dispatch(changeViewType(ViewType.login))
    dispatch(setLoginApiVersion(LoginApiVersion.newApi))
    loginNew({ pwd: pwdStr })
  }

  return (
    <Flex
      width="100vw"
      height="100vh"
      direction="column"
      align="center"
      justify="center"
    >
      <Flex
        direction="column"
        align="center"
        padding="16px"
        width="500px"
        background="#30313c"
        borderRadius="10px"
      >
        <Text color="white" fontSize="16px" marginBottom="20px">
          设置企业登录密码
        </Text>
        <InputGroup size="md" flex={1} height="100%" width={"450px"}>
          <Input
            type={showViewIcon ? "text" : "password"}
            background="rgb(37, 38, 46)"
            color="white"
            variant="unstyled"
            paddingX="12px"
            paddingY="8px"
            _placeholder={{ color: "#999999;" }}
            fontSize="15px"
            borderRadius="8px"
            placeholder="输入企业登录密码"
            onChange={(e) => {
              const value = e.target.value.trim()
              setPwdVal(value)
              if (value) {
                // 弱密码校验
                const verifyResult: PasswordValidationResult = validatePassword(
                  value,
                  currentUser?.uid + "@kingsoft.com"
                )

                if (!verifyResult.isValid) {
                  setErrMsg(`${verifyResult.errors.join(", ")}`)
                  return
                } else {
                  setErrMsg("")
                }
              } else {
                setErrMsg("")
              }

              dispatch(
                updateLoginStatus({ msg: "", status: LoginStatus.logging })
              )
            }}
            onKeyDown={(event) => {
              // 回车键触发登录
              if (event.key === "Enter") {
                handleConfirmPwd()
              }
            }}
          />
          <InputRightElement>
            <IconButton
              variant="text"
              aria-label={showViewIcon ? "Mask password" : "Reveal password"}
              icon={
                showViewIcon ? (
                  <ViewOffIcon color="blue.500" />
                ) : (
                  <ViewIcon color="blue.500" />
                )
              }
              onClick={() => setShowViewIcon(!showViewIcon)}
            />
          </InputRightElement>
        </InputGroup>
        <Text color="red" fontSize="13px" marginTop="8px" height={"34px"}>
          {msg}
        </Text>
        <Button
          width="100%"
          height="45px"
          marginTop="12px"
          variant="outline"
          border="1px solid rgba(255, 255, 255, 0.21)"
          color="#CCCCCC"
          colorScheme="whiteAlpha"
          onClick={() => {
            handleConfirmPwd()
          }}
        >
          确定
        </Button>
      </Flex>
    </Flex>
  )
}
export default SetKCPwdView
